import "./afp.css";

const Afp = () => {
  return (
    <div
      className="afp-wrapper"
      style={{
        backgroundImage: "url('bgafp1.webp')",
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
        backgroundAttachment: "fixed",
        width: "100%",
        overflowX: "hidden",
      }}
    >
      <div className="afp-heading">
        <h1>✈️ Air Freight Pallets</h1>
      </div>

      <div className="afp-box afp-left">
        <div className="grid-item item-1">
          <h2>🧊 Measurements</h2>
          <ul className="measurement-list">
            <li>Base Dim Outside: 1.5 × 1.5m</li>
            <li>Height Outside: 1.6m</li>
            <li>Usable Volume: 3m3</li>
            <li>Dimension Inside: 1.4 × 1.4 × 1.5m</li>
          </ul>
        </div>
        <div className="grid-item item-2">
          <h3>📦 LD3 Container</h3>
          <img src="/ld3.webp" alt="LD3 Container" className="ld3-img" />
        </div>
        <div className="grid-item item-3">
          <h2 className="code">🌟 Code - AKE / AVE</h2>
          <p className="para">
            <strong>Acceptable for</strong> A300, A310, A330, A340, B747-200F,
            B747-400, B767-400, B767(DE), MD11F
          </p>
        </div>
      </div>

      <div className="afp-box afp-right">
        <div className="grid-item item-1">
          <h2>🧊 Measurements</h2>
          <ul className="measurement-list">
            <li>Base Dim Outside: 3.1 × 2.2m</li>
            <li>Usable Volume: 3 × 2.1m</li>
          </ul>
        </div>
        <div className="grid-item item-2">
          <h3>📦 Standard Pallet</h3>
          <img
            src="/standardpallet.webp"
            alt="Standard Pallet"
            className="ld2-img"
          />
        </div>
        <div className="grid-item item-3">
          <h2 className="code">🌟 Code - PAG , PAJ</h2>
          <p className="para">
            <strong>Acceptable for</strong> A300, A31, A330, A340, B747-200F,
            B747-400, MD11F
          </p>
        </div>
      </div>

      <div className="afp-box afp-left">
        <div className="grid-item item-1">
          <h2>🧊 Measurements</h2>
          <ul className="measurement-list">
            <li>Base Dim Outside: 3.1 × 2.4m</li>
            <li>Usable Volume: 3 × 2.3m</li>
          </ul>
        </div>
        <div className="grid-item item-2">
          <h3>📦 10FT Pallet</h3>
          <img src="/10ftpallet.webp" alt="10ft pallet" className="ld3-img" />
        </div>
        <div className="grid-item item-3">
          <h2 className="code">🌟 Code - PQP , PMC</h2>
          <p className="para">
            <strong>Acceptable for</strong> A300, A310, A330, A340, B747-200F,
            B747-400, MD11F
          </p>
        </div>
      </div>

      <div className="afp-box afp-right">
        <div className="grid-item item-1">
          <h2>🧊 Measurements</h2>
          <ul className="measurement-list">
            <li>Base Dim Outside: 6 × 2.4m</li>
            <li>Usable Volume: 5.9 × 2.3m</li>
          </ul>
        </div>
        <div className="grid-item item-2">
          <h3>📦 20FT Pallet</h3>
          <img src="/20ftpallet.webp" alt="20ft Pallet" className="ld2-img" />
        </div>
        <div className="grid-item item-3">
          <h2 className="code">🌟 Code - PGE</h2>
          <p className="para">
            <strong>Acceptable for</strong> B747-200F, MD11F
          </p>
        </div>
      </div>
    </div>
  );
};

export default Afp;
